import type { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';

export function isUserOrgOwner(
  user: ApiUser | null | undefined,
  orgId?: string,
): boolean {
  return Boolean(user && orgId && user.orgs?.find((o) => o.id === orgId));
}
